'use client';

import { createContext, useContext } from 'react';

const ContainerElementContext = createContext<HTMLDivElement | null>(null);

const useContainerElementContext = () => {
  const containerElement = useContext(ContainerElementContext);

  if (containerElement) return containerElement;

  if (typeof document !== 'undefined') return document.body as HTMLDivElement;

  return null;
};

export { useContainerElementContext };
export default ContainerElementContext;
